<template>
  <div class="app-header">
    <sumaho-order-header v-if="isSumahoOrder" @openSideMenu="setIsSideMenuOpen(true)" />
    <pre-order-header v-else @openSideMenu="setIsSideMenuOpen(true)" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import PreOrderHeader from '@/components/header/PreOrderHeader'
import SumahoOrderHeader from '@/components/header/SumahoOrderHeader'
export default {
  components: {
    PreOrderHeader,
    SumahoOrderHeader,
  },
  computed: {
    ...mapGetters({
      seatNo: 'seat/getSeatNo',
    }),
    isSumahoOrder() {
      // 座席番号が0以外であればスマホで注文（0の際は事前オーダー
      return this.seatNo !== 0
    },
  },
  methods: {
    ...mapActions({
      setIsSideMenuOpen: 'setting/setIsSideMenuOpen',
    }),
  },
}
</script>
<style lang="scss" scoped>
.app-header {
  position: fixed;
  top: 0;
  width: 100%;
  height: 55px;
  background: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  z-index: 10;
  .is-app & {
    background: #242424;
    box-shadow: none;
  }
}
</style>
